<template>
    <div class="page m-dailyStudy">
        <el-tabs class="page-tab" v-model="tab" type="border-card">
            <el-tab-pane label="每日一练题组" name="1">
                <topic-set
                    ref="dailyTopicSet"
                    :type="3">
                </topic-set>
            </el-tab-pane>

            <el-tab-pane label="排行榜" name="2">
                <daily-rank></daily-rank>
            </el-tab-pane>
        </el-tabs>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOut">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
import TopicSet from "./Components/TopicSet";
import DailyRank from "./Components/DailyRank";

export default {
    components: {
        TopicSet,
        DailyRank
    },

    data() {
        return {
            tab: '1'
        }
    },

    methods: {
        onSubpageClose() {
            this.$refs.dailyTopicSet && this.$refs.dailyTopicSet.getTopicList()
        }
    },
}
</script>

<style lang="scss">
.m-dailyStudy {
    .page-tab {
        display: flex;
        flex-direction: column;
        height: 100%;

        .el-tabs__content {
            flex: 1;
            padding: 0 15px;

            .el-tab-pane {
                height: 100%;
            }

        }
    }
}
</style>
